'use strict';

define('vb/private/stateManagement/router/historyAdapter',[
  'vb/private/stateManagement/router/urlAdapter',
  'vb/private/stateManagement/router/vbRouter',
], (UrlAdapter, VbRouter) => {
  /**
   * @typedef {import('vb/private/stateManagement/router/stateChange').default} StateChange
   */

  /**
   * An adapter used to manage the router state using the browser history instead of the URL
   * This is used by the SwitcherRootRouter.
   */
  class HistoryAdapter extends UrlAdapter {
    /**
     * @param {string} basePagePath
     */
    constructor(basePagePath) {
      super();

      /**
       * @private
       * @type {string}
       */
      this._basePagePath = basePagePath;
    }

    /**
     * @returns {string}
     */
    getPath() {
      let path;

      // To retrieve the portion of the path representing the routers state,
      // remove the base portion of the path.
      const state = window.history.state;
      const vbState = state && state.vbState;
      const pagePath = vbState && vbState.pagePath;

      if (pagePath) {
        path = pagePath.replace(this._basePagePath, '');
      }

      return path;
    }

    /**
     * Construct an array of states where each item is an object made of a router and
     * the new state for it.
     * @param {Object} transition An object with properties describing the transition.
     * @return {!Array.<StateChange>}
     * @throws Error when parsing of router param fails.
     */
    parse(transition) {
      let changes = [];

      const path = this.getPath();
      if (path) {
        changes = UrlAdapter.getChangesFromSegments(transition.rootRouter, VbRouter.getSegments(path));
      }

      return changes;
    }
  }

  return HistoryAdapter;
});

